import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Spinner, ProgressBar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ModalGeneratingPDF = ({ show, title, message }) => {
    return (
        <Modal
            show={show}
            centered
            backdrop="static"
            keyboard={false}
            size="sm"
            className="modal-generating-pdf"
        >
            <Modal.Body className="text-center p-4">
                {/* Spinner animado */}
                <div className="mb-3 position-relative d-inline-block">
                    <Spinner
                        animation="border"
                        variant="primary"
                        style={{ width: '4rem', height: '4rem' }}
                    />
                    <div 
                        className="position-absolute top-50 start-50 translate-middle"
                        style={{ fontSize: '1.5rem' }}
                    >
                        <FontAwesomeIcon 
                            icon="file-pdf" 
                            className="text-danger"
                            beat
                        />
                    </div>
                </div>

                {/* T�tulo */}
                <h5 className="mb-2 fw-bold text-primary">
                    {title || 'Generando PDF'}
                </h5>

                {/* Mensaje */}
                <p className="text-muted mb-3 small">
                    {message || 'Por favor espere mientras se genera el documento...'}
                </p>

                {/* Barra de progreso indeterminada */}
                <ProgressBar 
                    animated 
                    now={100} 
                    variant="primary"
                    style={{ height: '4px' }}
                />

                {/* Nota adicional */}
                <p className="text-muted mt-3 mb-0 small">
                    <FontAwesomeIcon icon="circle-info" className="me-1" />
                    No cierre esta ventana
                </p>
            </Modal.Body>

            {/* Estilos inline para animaciones adicionales */}
            <style jsx="true">{`
                .modal-generating-pdf .modal-content {
                    border-radius: 12px;
                    border: none;
                    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
                }
                
                .modal-generating-pdf .modal-body {
                    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
                }

                @keyframes pulse {
                    0%, 100% {
                        opacity: 1;
                    }
                    50% {
                        opacity: 0.6;
                    }
                }
            `}</style>
        </Modal>
    );
};

ModalGeneratingPDF.propTypes = {
    show: PropTypes.bool.isRequired,
    title: PropTypes.string,
    message: PropTypes.string
};

export default ModalGeneratingPDF;
